import {createSelector} from '@reduxjs/toolkit'
import {toggle} from 'opticks'
import {RootState} from 'store'

import {searchApi} from '@daedalus/core/src/sapi/services/searchApi'
import {ContentHotel} from '@findhotel/sapi'

export const getHotelResult = (
  state: RootState,
  hotelId?: string
): ContentHotel | Partial<ContentHotel> | undefined | null => {
  const newSapiEndpoints = toggle('32ab3efe-new-sapi-endpoints-v2', false, true)

  if (newSapiEndpoints && hotelId) {
    const queryData = searchApi.endpoints.getHotel.select({hotelId: hotelId})(
      state
    )
    return queryData.data
  }

  return state.hotelApi?.data
}

export const getHotelName = (state: RootState): string | undefined => {
  const hotelResult = getHotelResult(state)
  return hotelResult?.hotelName
}
export const getHotelId = createSelector([getHotelResult], hotel => {
  return hotel?.objectID
})
